import React, { useContext, useState, useEffect } from 'react';
import styles from './TableView.module.css';
import moment from 'moment';
import 'moment-timezone';
import 'moment-duration-format';
import searchIcon from '../../assets/images/search-icon.svg';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../store/auth-context';
import { URL } from '../../constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort } from '@fortawesome/free-solid-svg-icons';
import { DashboardContext } from '../../store/dashboard-context';

interface TicketData {
    contact_reason: string;
    assignee_email: string;
    review_score: number;
    date: string;
}

const TableView = (props: any) => {
    const authCtx = useContext(AuthContext);
    const dashboardCtx = useContext(DashboardContext);
    const [searchedFromListID, setSearchedFromListID] = useState('');

    useEffect(() => {
        if (searchedFromListID.length === 8) {
            dashboardCtx.searchTickets(searchedFromListID);
        }
    }, [searchedFromListID]);

    const handleIconClick = () => {
        dashboardCtx.searchTickets(searchedFromListID);
    };

    const list = props.data.map((ticket: any) => {
        return (
            <div className={`${styles.ticketDetails}`} key={ticket.thread_id}>
                <div className={styles.ticketTitle}>
                    <Link to={`/${authCtx.currentTenant}/${URL.conversation}/${ticket.thread_id}?session_id=${ticket.session_id}`}>{ticket.thread_id}</Link>
                </div>
                <div>{ticket.contact_reason}</div>
                <div>{ticket.team_member}</div>
                <div>{Math.round(ticket.review_score)}%</div>
                <div>{moment(ticket.solved_date).format('MMMM DD, YYYY')}</div>
            </div>
        )
    });    

    const getSortIcon = (columnName: keyof TicketData) => {
        if (!dashboardCtx.sortConfig) return <FontAwesomeIcon icon={faSort} />;
        if (dashboardCtx.sortConfig.key === columnName) {
            return dashboardCtx.sortConfig.direction === 'asc' ? '▲' : '▼';
        } else {
            return <FontAwesomeIcon icon={faSort} />;
        }
    };

    return (
        <div className={styles.tableContainer}>
            <div className={`d-flex justify-content-between align-items-center`} >
                <div>
                    {dashboardCtx.isExported ? (
                        <div className="alert alert-success" role="alert">
                            {dashboardCtx.exportedMsg}
                        </div>
                    ): dashboardCtx.isExportedError ? (
                        <div className="alert alert-danger" role="alert">
                            Something went wrong!
                        </div>
                    ): null}
                </div>
                <button className={`btn btn-primary ${styles.exportButton}`} onClick={dashboardCtx.exportCsv}>Export as CSV</button>
            </div>
            <div className={`${styles.header} d-flex justify-content-between align-items-center`}>
                <div>
                    <h6 className='text-uppercase'>Tickets</h6>
                </div>
                <div className={`d-flex align-items-center me-2 ${styles.search}`}>
                    <input placeholder='Search ticket id' id="search-bar" type="text" value={searchedFromListID} onChange={(e) => setSearchedFromListID(e?.target?.value)} />
                    <img src={searchIcon} alt="Search Icon" onClick={handleIconClick}/>
                </div>
            </div>
            <div className={styles.ticketTable}>
                <div className={styles.ticketTableHeader}>
                    <h6>Ticket ID</h6>
                    <h6 onClick={() => dashboardCtx.onSort('contact_reason')}>Contact Reason {getSortIcon('contact_reason')}</h6>
                    <h6 onClick={() => dashboardCtx.onSort('assignee_email')}>Team Member {getSortIcon('assignee_email')}</h6>
                    <h6 onClick={() => dashboardCtx.onSort('review_score')}>QA Score {getSortIcon('review_score')}</h6>
                    <h6 onClick={() => dashboardCtx.onSort('date')}>Solved Date {getSortIcon('date')}</h6>
                </div>
                <div>
                    {props.data.length > 0 ? list : <div className="text-center mt-5 text-secondary">No data available!</div>}
                </div>
            </div>
        </div>
    )
}

export default TableView
